export const defaultYearlyIncome = 600000;
export const monthsInYear = 12;
export const uforetrygd = 0.66;
export const maxCoveredGs = 6;
export const lowIncomeMaxRate = 300000;
export const grunnbelop = 130160;